<template>
    <span class="d-inline-block">
        <i class="fas fa-pencil-alt hand primary-color" :title="$t('pages.EditUserEvent')"  @click="modalShow = !modalShow"></i>
        <b-modal
                ref="createModal"
                size="lg"
                :no-close-on-backdrop="true"
                :title="$t('pages.EditUserEvent')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-center">
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <div class="alert alert-success" v-if="success">{{success}}</div>
                <formly-form :form="form" :model="model" :fields="fields" ref="create"/>
            </div>

            <div slot="modal-footer" class="w-100 text-right">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >
                    {{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="danger"
                        @click="submit"
                        :disabled="disabled"
                >
                    {{$t('button.Continue')}}
                </b-btn>
            </div>
        </b-modal>
    </span>
</template>

<script>
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import { mapActions } from 'vuex';
  import find from 'lodash/find';
  import { ERROR_MESSAGES } from '../../constants';
  import { TRANSPORT_OPTIONS, TRANSPORT_TYPES } from '../../constants/eventContant';

  export default {
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    props: ['eventId', 'transportIn', 'transportOut', 'note'],

    data() {
      this.event = find(this.$store.state.home.availableEvents, { id: this.eventId });

      const timesIn = this.event.busInTimes.map((time) => {
        return {
          value: time.time,
          label: time.time
        };
      });
      const timesOut = this.event.busOutTimes.map((time) => {
        return {
          value: time.time,
          label: time.time
        };
      });

      const transportInOutWithTime = this.transportIn == 0 || this.transportIn == 1;
      const transportOutOutWithTime = this.transportOut == 0 || this.transportOut == 1;

      return {
        modalShow: false,
        disabled: false,
        error: '',
        success: '',
        form: {},
        model: {
          note: this.note,
          transportTimeOut: transportOutOutWithTime ? '' : {
            label: this.transportOut,
            value: this.transportOut
          },
          transportTimeIn: transportInOutWithTime ? '' : {
            label: this.transportIn,
            value: this.transportIn
          },
          transportTypeIn: transportInOutWithTime ? TRANSPORT_OPTIONS[this.transportIn] : TRANSPORT_OPTIONS[2],
          transportTypeOut: transportOutOutWithTime ? TRANSPORT_OPTIONS[this.transportOut] : TRANSPORT_OPTIONS[2],
        },
        fields: [
          {
            key: 'transportTypeIn',
            type: 'multi-select',
            options: TRANSPORT_OPTIONS,
            required: true,
            templateOptions: {
              label: this.$t('fields.transportTypeIn'),
            }
          },
          {
            key: 'transportTimeIn',
            type: 'multi-select',
            options: timesIn,
            templateOptions: {
              label: this.$t('fields.transportTime'),
              multiple: false,
              closeOnSelect: true
            },
            display: (field, model) => {
              return model.transportTypeIn && model.transportTypeIn.value === TRANSPORT_TYPES.BUS;
            },
          },
          {
            key: 'transportTypeOut',
            type: 'multi-select',
            required: true,
            options: TRANSPORT_OPTIONS,
            templateOptions: {
              label: this.$t('fields.transportTypeOut'),
            },
          },
          {
            key: 'transportTimeOut',
            type: 'multi-select',
            options: timesOut,
            templateOptions: {
              label: this.$t('fields.transportTime'),
              multiple: false,
              closeOnSelect: true
            },
            required: false,
            display: (field, model) => {
              return model.transportTypeOut && model.transportTypeOut.value === TRANSPORT_TYPES.BUS;
            }
          },
          {
            key: 'note',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Note'),
              note: this.$t('eventRegistration.dietNote')
            }
          },
        ]
      }
    },
    methods: {
      ...mapActions(['editUserEvent']),
      submit(e) {
        e.preventDefault();

        this.disabled = true;
        this.error = '';

        const data = {
          note: this.model.note,
          transportOut: this.model.transportTimeOut && this.model.transportTypeOut.value === TRANSPORT_TYPES.BUS ? this.model.transportTimeOut.value : JSON.stringify(this.model.transportTypeOut.value),
          transportIn: this.model.transportTimeIn && this.model.transportTypeIn.value === TRANSPORT_TYPES.BUS ? this.model.transportTimeIn.value : JSON.stringify(this.model.transportTypeIn.value),
          eventId: this.eventId
        };

        this.editUserEvent(data).then(() => {
          this.disabled = false;
          this.modalShow = false;
          window.location.reload(true);
        }, () => {
          this.disabled = false;
          this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
        })
      }
    }
  };
</script>

<style scoped>
</style>
